<script>
    import SubPageHeader from '../components/SubPageHeader.svelte'
    import SubNav from '../components/SubNav.svelte'
    import ScheduleList from '../components/ScheduleList.svelte'
    import ScheduleDaySwitcher from '../components/ScheduleDaySwitcher.svelte'
    import {  onMount, afterUpdate } from 'svelte';
    import {replace} from 'svelte-spa-router'
    

    import { 
        translations, 
        current_lang, 
        festival_days, 
        artists_api_storage,
        venues_api_storage,
        main_venue_ids,
        y_scroll_pos_history
    } from '../stores.js';

    export let params = {date};

    let all_artists = null
    let all_days = null;
    let selected_day = null;
    let selected_day_display = null;
    let day_artists = [];
    let readable_venues = [];
    
    festival_days.subscribe(value => {
		all_days = value;
        if(selected_day == null){
            if(params.date){
                selected_day = params.date;
                selected_day_display = get_full_display_date(selected_day);
            }else{
                selected_day = all_days[0].date;
                selected_day_display = get_full_display_date(all_days[0].date);
            }
        }
    });

    venues_api_storage.subscribe(value => {
        if(value != null){
            let venuedata;
            if($current_lang == "FI"){
                venuedata = value.fi;
            }
            if($current_lang == "EN"){
                venuedata = value.en;
            }

            let venues_to_add = [];
            for(let i = 0; i < venuedata.length; i++){
                let venueinfo = {
                    "id":   venuedata[i].id,
                    "name": venuedata[i].name,
                }
                venues_to_add.push(venueinfo);
            }
            readable_venues = venues_to_add;
        }
    });

    function get_full_display_date(date){
        return get_day_name(date, $current_lang) + " " + convert_date(date);
    }

    function is_main_concert_show(appearance){
        let day = $festival_days.find(x => x.date == appearance.dateYmd);
        if(day){
            if(day.daytype == "main"){
                if($main_venue_ids.includes(parseInt(appearance.place.term_id))){
                    return true;
                }
            }
        }
        return false;
    }

    function set_day_artists(){
        for(let i = 0; i < all_days.length; i++){
            let date = all_days[i].date;
            //init looped days artists
            day_artists[date] = [];

            //find looped days artists
            for(let n = 0; n < all_artists.length; n++){
                let artist = all_artists[n];
                
                for(let k = 0; k < artist.shows.length; k++){
                    let appearance = all_artists[n].shows[k];
                    if(!is_main_concert_show(appearance)){                        
                        if(appearance.dateYmd == date){
                            // if(date == "2023-07-10"){
                            //     console.log(all_artists[n].h1)
                            // }
                            //remove all other shows than today 
                            //(so they are easier to output in schedule and no day checking needed there)
                            let copyArtist = clean_artist_shows(artist, date);

                            day_artists[date].push(copyArtist);
                            day_artists = day_artists;
                            break;
                        }
                    }
                }
            }
        }
    }

    function clean_artist_shows(artist, date){
        let copiedArtist = structuredClone(artist);

        let cleaned_shows = copiedArtist.shows.filter(x => x.dateYmd == date);
        copiedArtist.shows = cleaned_shows;

        //pikafiksaus 11.7.2023
        if(date == "2023-07-14" && artist.id == 1156){
            let newShows = [];
            for(let i = 0; i < copiedArtist.shows.length; i++){
                if(copiedArtist.shows[i].place.term_id == 12){
                    //console.log(copiedArtist.shows);
                    //console.log("test");
                }else{
                    newShows.push(copiedArtist.shows[i]);
                }
            }
            if(newShows.length > 0){
                copiedArtist.shows = newShows;
                copiedArtist = copiedArtist;
            }
        }

        //clone artist
        return copiedArtist;
    }

    artists_api_storage.subscribe(value => {
		all_artists = value;
        if(all_artists != null){
            set_day_artists();
        }
    });

    function convert_date(date){
        let date_parts = date.split("-");
        let display_date = date_parts[2] + "." + date_parts[1] + ".";

        return display_date;
    }

    function get_day_name(date, locale)    {
        var date = new Date(date);
        return date.toLocaleDateString(locale, { weekday: 'short' });        
    }

    function show_day(day){
        selected_day = day;
        selected_day_display = get_full_display_date(selected_day);
        replace('/other-events/'+selected_day);

        switcher_days = get_day_switcher_days(selected_day);

        refresh_switcher_days();
    }

    function refresh_switcher_days(){
        next_status = true;
        prev_status = true;

        if(switcher_days.next == null){
            next_status = false;
        }
        if(switcher_days.prev == null){
            prev_status = false;
        }
    }

    function get_day_switcher_days(date){
        let switcher_days = {
            prev: null,
            current: date,
            next: null,
        };

        let festival_days_list = $festival_days;

        for(let i = 0; i < festival_days_list.length; i++){
            if(date == festival_days_list[i].date){
                if (festival_days_list[i - 1] !== undefined) {
                    switcher_days.prev = festival_days_list[i - 1].date;
                }

                if (festival_days_list[i + 1] !== undefined) {
                    switcher_days.next = festival_days_list[i + 1].date;
                }
                return switcher_days;
            }
        }
        
        return switcher_days;
    }

    let switcher_days = null;
    let prev_status = null;
    let next_status = null;

    afterUpdate(() => {
        if(all_days == null){
            return;
        }
    });

    onMount(() => {
        if(all_days == null){
            return;
        }

        if(selected_day == null){
            if(params.date){
                selected_day = params.date;
            }else{
                selected_day = main_days[0].date;
            }
        }

        show_day(selected_day);
    });

    function prev_day(){
        if(switcher_days.prev != null){
            show_day(switcher_days.prev);
        }
    }

    function next_day(){
        if(switcher_days.next != null){
            show_day(switcher_days.next);
        }
    }
</script>

<SubPageHeader page_title={$translations["OTHER_EVENTS"][$current_lang]} is_section_main_page={true}/>
<SubNav>
    {#if next_status != null && prev_status != null}
        <ScheduleDaySwitcher text={selected_day_display} on:prev={prev_day} on:next={next_day} {prev_status} {next_status}/>
    {/if}
</SubNav>
<div class="content-container">
    {#if day_artists[selected_day] != null &&  day_artists[selected_day].length > 0}
        <ScheduleList display_date={get_full_display_date(selected_day)} venues={readable_venues} artists={day_artists[selected_day]} />
    {:else}
        <div class="content-container">
            {#if $current_lang == "FI"}
                <p>Sisällön lataaminen ei onnistunut. Ongelma voi johtua siitä, että laitteesi ei saa yhteyttä verkkoon. Jos näet tämän virheilmoituksen vielä yhteyden palauduttua, voit koittaa sulkea sovelluksen ja käynnistää sen uudelleen.</p>
            {:else}
                <p>Could not load content. Your device may be offline. If your connection has been restored and you still see this error, you can try restarting the app.</p>
            {/if}
        </div>
    {/if}
</div>